import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { get } from 'lodash'
import { modal } from 'helpers/decorators'
import { Table, MaterialModal } from 'components/layout'
import { Button, Title } from 'components/misc'
import MODALS from 'constants/layout/modals'
import { ROLES } from '../../../constants/enums'

const styles = {
  btn: { padding: '5px 20px' }
}

@modal.trigger()
class ChooseRole extends Component {
  static propTypes = {
    modalObj: PropTypes.shape({
      onResolve: PropTypes.func,
      userTypes: PropTypes.array
    })
  }

  handleClick = ({ id, userType, name, hierarchyLevelType, regionId }) => {
    const { modalObj } = this.props

    modalObj.data &&
      modalObj.data.onResolve({
        id,
        userType,
        name,
        hierarchyLevelType,
        regionId
      })
  }

  render() {
    const { modalObj } = this.props

    const userTypes = get(modalObj, 'data.userTypes', [])

    return (
      <MaterialModal.Body id={MODALS.CHANGE_ROLE} noHeader noClose>
        <MaterialModal.Content minimal>
          <Title h2 intlKey="label.choose_how_you_want_to_login">
            Choose how you want to login
          </Title>
          <Table.Wrap>
            <tbody>
              {userTypes.map(({ userType, organizations }) => {

                  if(userType === ROLES.ASSESSOR.u && organizations) {
                    const organization = organizations[0]

                    const orgId = get(organization, 'id')

                    const hierarchyLevelType = get(organization, 'hierarchyLevelType')

                    const name = get(organization, 'name')

                    const regionId = get(organization, 'regionId')

                    return [(<Table.Row key={userType}>
                      <Table.Cell>
                        <FormattedMessage
                          id={'roles.' + userType}
                          defaultMessage={userType}
                        />
                      </Table.Cell>
                      <Table.Cell>---</Table.Cell>
                      <Table.Cell>
                        <Button
                          style={styles.btn}
                          type="button"
                          onClick={() =>
                            this.handleClick({
                              orgId,
                              userType,
                              name,
                              hierarchyLevelType,
                              regionId
                            })}
                        >
                          Select
                        </Button>
                      </Table.Cell>
                    </Table.Row>)]
              } else {
                    return organizations &&
                    organizations.map(({
                                         id,
                                         name,
                                         hierarchyLevelType,
                                         regionId
                                       }) => (
                      <Table.Row key={userType + id}>
                        <Table.Cell>
                          <FormattedMessage
                            id={'roles.' + userType}
                            defaultMessage={userType}
                          />
                        </Table.Cell>
                        <Table.Cell>{name}</Table.Cell>
                        <Table.Cell>
                          <Button
                            style={styles.btn}
                            type="button"
                            onClick={() =>
                              this.handleClick({
                                id,
                                userType,
                                name,
                                hierarchyLevelType,
                                regionId
                              })}
                          >
                            Select
                          </Button>
                        </Table.Cell>
                      </Table.Row>
                    ))
                  }
                })}
            </tbody>
          </Table.Wrap>
        </MaterialModal.Content>
      </MaterialModal.Body>
    )
  }
}

export default ChooseRole
